import { Modal } from "antd";

import Cancel from "../../../../assets/cancel.svg";
import Styles from "../css/payWithQuickbucks.module.scss";
import OtpInput from "react-otp-input";
import { useState } from "react";

const PayWithQuickbucksPinModal = (props: any) => {
  const { pin, hideCloseIcon } = props;
  return (
    <div>
      <Modal
        title="Basic Modal"
        destroyOnClose={true}
        centered
        width={400}
        open={props.isModalOpen}
        onOk={props.handleOk}
        className={Styles.customModal}
        modalRender={modal => (
          <div style={{ borderRadius: '15px' }}>
            {modal}
          </div>
        )}
      // onCancel={props.handleCancel}
      >
        <div className={Styles.modalContentVerification}>
          {/* {hideCloseIcon === "" ||
            (null && ( */}
          <div className={Styles.cancelDiv}>
            <img
              onClick={props.goToTerms}
              src={Cancel}
              className={Styles.cancelIcon}
              alt="horse"
            />
          </div>
          {/* ))} */}
          <div
            style={{
              textAlign: "left",
              paddingTop: hideCloseIcon === "" || null ? "1.5em" : "0em", marginTop: '0em', fontSize: '1.3rem', marginBottom: '0em'
            }}
            className={Styles.titles}
          >
            Please enter your PIN
          </div>

          <div className={Styles.inputTitle} style={{ paddingTop: "1em", marginBottom: '0em' }}>
            PIN
            {/* <span className={Styles.asteriks}>*</span> */}
          </div>
          <OtpInput
            value={pin}
            onChange={props.onChangePinSelectChange}
            numInputs={4}
            inputType="password"
            shouldAutoFocus={true}
            containerStyle={{ justifyContent: "space-between" }}
            inputStyle={{
              width: "23%",
              height: "60px",
              background: "none",
              border: "1px solid #5D6B82",
              borderRadius: "7px",
              marginTop: "0.1em",
              color: "gray",
              fontWeight: "bolder",
              fontSize: "2em",
              cursor: "pointer",
            }}

            renderSeparator={<span> </span>}
            // renderInput={(props) => <input {...props} />
            renderInput={(inputProps: any, index: number) => (
              <input
                {...inputProps}
                onKeyDown={(e) => {
                  const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"];
                  const isNumber = /^\d$/.test(e.key);

                  // Allow only numbers and navigation
                  if (!isNumber && !allowedKeys.includes(e.key)) {
                    e.preventDefault();
                  }

                  // Handle Backspace to move focus back
                  if (e.key === "Backspace" && !inputProps.value) {
                    const prevInput = document.querySelectorAll('input')[index - 1] as HTMLInputElement;
                    if (prevInput) {
                      prevInput.focus();
                      prevInput.value = "";
                      e.preventDefault();
                    }
                  }
                }}
              />
            )
            }

          />
          <button
            style={{
              background: pin?.length < 4 ? "#d9d9d9" : "",
            }}
            disabled={pin?.length < 4}
            onClick={props.verifyPin}
            className={Styles.btn}
          >
            SUBMIT
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default PayWithQuickbucksPinModal;
